import { useEffect, useRef } from 'react';

import Dropdown from 'molecules/Dropdown';

import type { FC } from 'react';

export type StepThreeProps = {
  eyebrow?: string;
  heading?: string;
  body?: string;
  disclaimer?: string;
  handleDetailedDataValue: (value: number) => void;
  moveNextStep: (value: number) => void;
  movePrevStep: (value: number) => void;
  handleInvalid: (
    e: HTMLInputElement | HTMLTextAreaElement,
    value?: string | number | null,
    isDropdown?: boolean,
  ) => boolean;
  detailedDataRate?: number;
  parentStep?: number;
};

const StepThree: FC<StepThreeProps> = ({
  eyebrow,
  heading,
  body,
  disclaimer,
  handleDetailedDataValue,
  moveNextStep,
  movePrevStep,
  handleInvalid,
  detailedDataRate,
  parentStep,
}) => {
  const inputRef = useRef<HTMLButtonElement>(null);
  const handleMoveStep = () => {
    if (handleInvalid(inputRef.current as HTMLInputElement, detailedDataRate, true)) {
      return;
    }
    moveNextStep(4);
  };

  const handleValue = (value: number) => {
    handleInvalid(inputRef.current as HTMLInputElement, 'yes', true);
    handleDetailedDataValue(value);
  };

  useEffect(() => {
    parentStep === 4 && handleMoveStep();
  }, [parentStep]);

  return (
    <div className="mx-auto flex w-full flex-col gap-8 border border-gray-100 bg-white p-6 shadow-xl sm:max-w-[567px] md:max-w-[592px] md:px-12 md:py-8">
      <div className="flex w-full flex-col items-center gap-4 text-center">
        {eyebrow && <p className="w-fit text-xs font-bold uppercase text-gray-500 sm:block">{eyebrow}</p>}
        {heading && <p className="text-display-xs-mobile font-bold text-gray-900">{heading}</p>}
        {body && <p className="text-md text-gray-700">{body}</p>}
        <Dropdown
          label="Select answer"
          items={[{ label: 'Yes' }, { label: 'No' }]}
          type="filter"
          defaultValue={detailedDataRate}
          onChange={handleValue}
          inputRef={inputRef}
        />
        <button className="w-full bg-gray-900 p-3 text-md font-semibold text-white sm:block" onClick={handleMoveStep}>
          Next
        </button>
        <button className="w-fit bg-white text-md font-semibold text-gray-900 sm:block" onClick={() => movePrevStep(2)}>
          Back
        </button>
        {disclaimer && <p className="text-sm text-gray-500">{disclaimer}</p>}
      </div>
    </div>
  );
};

export default StepThree;
